var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"elevation-0 indigo lighten-5 pb-1"},[_c('v-card-title',{staticClass:"pl-0"},[_vm._v("XSLT")]),_vm._v(" "),_c('v-card-text',{staticClass:"ml-0 vop--ace-editor-container",style:({ height: _vm.editorHeight })},[_c('div',{ref:"xsltEditor",staticClass:"vop--ace-editor"})]),_vm._v(" "),_c('v-card-actions',{staticClass:"pl-0"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de6af0b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/XVAT/Rule/XSLTEditor.vue
// module id = null
// module chunks = 